import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";

const DeleteTagModal = ({ tag, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const cautionMessages = [
    { id: 0, message: "Auto Plan triggers may start new plans on leads." },
    { id: 1, message: "Lead routing rules using this tag may lose criteria." },
  ];
  return (
    <Modal
      show={Boolean(tag)}
      onHide={onClose}
      closeOnEscape={false}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[650px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title="Delete Tag?" closeButton />

      {tag && (
        <Modal.Body className="tw-py-[8px] tw-flex tw-flex-col tw-gap-[24px] tw-overflow-auto">
          <Typography>
            Deleting <b>{tag.name}</b> will affect other settings in your CRM. It&apos;s applied to{" "}
            <b>
              {tag.peopleCount} {tag.peopleCount === 1 ? "person" : "people"}
            </b>
            .
          </Typography>
          <Typography component="div">
            <ul>
              {cautionMessages.map((m) => (
                <li key={m.id}>{m.message}</li>
              ))}
            </ul>
          </Typography>
          <Typography>
            This action can&apos;t be undone. We recommend checking your routing rules and temporarily pausing
            Auto Plan triggers first.
          </Typography>
        </Modal.Body>
      )}

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button
          schema="warning"
          size="medium"
          isLoading={loading}
          onClick={() => {
            setLoading(true);
            onDelete(tag).finally(() => {
              setLoading(false);
            });
          }}
        >
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteTagModal.propTypes = {
  tag: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

DeleteTagModal.defaultProps = {
  tag: null,
};

export default DeleteTagModal;
